
import {
	Component, Prop, Vue,
} from 'vue-property-decorator';
import LoanProjectionChart from '@/loan/components/LoanProjectionChart.vue';
import { LoanProjectionChartContext } from '@/loan/types/loan-projection-chart-context';

@Component({
	components: {
		LoanProjectionChart,
	},
})
export default class LoanSummaryProjection extends Vue {
	@Prop({ required: true })
	public context!: LoanProjectionChartContext;

	@Prop({ required: true })
	public startBalance!: number;
}
